// Test IDs for the Data Recovery TV Board.

export const DATA_RECOVERY = {
  page: 'data-recovery-page',
  title: 'data-recovery-title',
  configWarning: 'data-recovery-config-warning',
  summaryStrip: 'data-recovery-summary-strip',
  summaryStat: 'data-recovery-summary-stat',
  boardGrid: 'data-recovery-board-grid',
  column: 'data-recovery-column',
  columnHeader: 'data-recovery-column-header',
  columnCount: 'data-recovery-column-count',
  card: 'data-recovery-card',
  overflowIndicator: 'data-recovery-overflow-indicator',
  problemsStrip: 'data-recovery-problems-strip',
  problemCard: 'data-recovery-problem-card',
  lastUpdated: 'data-recovery-last-updated',
  healthPill: 'data-recovery-health-pill',
};
